import type { Provenance, ScorecardHole } from '../api/public'

/**
 * How a hole and its origin READ -- the words and the classes, not the markup.
 *
 * Separate from `MatchHoles.tsx` because React Fast Refresh cannot reload a
 * module that exports both components and plain functions, which is the same
 * reason `Async.tsx` was split off `useApi`. `statusShort` lived in TWO pages
 * verbatim before this; one copy is the point.
 */

/** How a score's origin reads. Manual and corrected are marked; ingested is the default. */
export const provenanceMark: Record<Provenance, string | null> = {
  ingested: null,
  manual: 'typed',
  corrected: 'corrected',
}

/** "2UP A" becomes "Mike 2" — a name, because "A" means nothing to a reader. */
export function statusShort(status: string, a: string, b: string): string {
  if (!status || status === 'AS') return 'AS'
  const match = /^(\d+)UP (A|B)$/.exec(status)
  if (!match) return status
  const leader = match[2] === 'A' ? a : b
  return `${leader.slice(0, 4)} ${match[1]}`
}

export function statusWords(status: string, a: string, b: string): string {
  if (!status || status === 'AS') return 'All square'
  const match = /^(\d+)UP (A|B)$/.exec(status)
  if (!match) return status
  return `${match[2] === 'A' ? a : b} ${match[1]} up`
}

export function holeClass(h: ScorecardHole): string {
  const parts = ['gross']
  if (h.provenance !== 'ingested') parts.push(`provenance-${h.provenance}`)
  if (h.replayed) parts.push('replayed')
  if (h.flagged) parts.push('flagged')
  return parts.join(' ')
}
